module.exports = __webpack_public_path__ + "static/media/coupon-icon-w.a29a86d4.svg";